'use strict';
import '../styles/main.scss';